(ns portal.password-reset-page.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            [common.widgets.auth-card :refer [auth-card]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.page :as page]
            [portal.password-reset-page.db :as form]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui password-reset-page []
  (let [{:keys [status error-message]} (use-subscribe [:form.password-reset/state])]
    (uix/use-effect (fn []
                      (rf/dispatch [:form.password-reset/init-form]))
                    [])
    ($ page/page {:sidebar false
                  :appbar false}
       ($ page/content-padding
          ($ auth-card {:on-submit #(rf/dispatch [:form.password-reset/submit])}
             ($ form-field
                {:label "Your new password"
                 :err-msg (form/use-error-message [:password])}
                ($ input
                   (merge (form/use-bind-control [:password])
                          {:type "password"})))
             ($ form-field
                {:label "Repeat your new password"
                 :err-msg (form/use-error-message [:repeat-password])}
                ($ input
                   (merge (form/use-bind-control [:repeat-password])
                          {:type "password"})))
             (when (= status :failure)
               ($ Alert {:severity "error"}
                  error-message))
             (if (= status :success)
               ($ Alert {:severity "success"}
                  "Your password is reset")
               ($ Button
                  {:variant "contained"
                   :type "submit"}
                  "Reset Password"))
             ($ Button
                {:href (r.easy/href :common/login)}
                "← Go back to login page"))))))
